import * as Yup from 'yup';

export default Yup.object().shape({
  id: Yup.number(),
  name: Yup.string().required('Banner Name is required').max(150),
});